import React from 'react';
import _ from 'lodash';

import Form from '../../../../gd-form/form/form-modal/form-modal.jsx';
import FormError from '../../../../gd-form/common/form-error/form-error.tsx';
import FormManager from '../../../../gd-form/common/form-manager';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit';

import SettingsFormProto from '../../settings-form-proto';
import Stepper from "core/gd-form/form-element/stepper/stepper";

class StringSettingsForm extends SettingsFormProto {

    constructor(props) {
        super(props);


        // add field
        this.initFormData.decimalPlaces = _.get(this.props.field, 'params.decimalPlaces', null);
        this.formStructure.fields.decimalPlaces = {
            type: 'select',
            isRequired: false,
            label: 'Decimal places',
            onUserChange: () =>  this.setState({reRender: 1})
        };


        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {

        result.type = gd.const.customFields.type.STRING;

        const field = this.props.field;
        field.label = result.name.trim();
        field.description = result.description;
        field.isRequired = result.isRequired;
        field.params = {
            decimalPlaces: result.decimalPlaces
        };

        this.props.onSubmit(field);
    }

    render() {
        return (
            <div className="form-container">
                {this.renderForm()}
                <div className="modal-submit">
                    <ButtonSubmitDeprecated form={this.form} className="submit" label="Submit" />
                </div>
            </div>
        );
    }

    renderForm() {

        return (
            <Form form={this.form} className="create-new-custom-field-form main" submitButton={false}>

                {this.renderType()}
                {this.renderName()}
                {this.renderDescription()}
                {this.renderIsRequired()}

                <div className="row cf">
                    <div className="label">Decimal places</div>
                    <div className="element">
                        <Stepper form={this.form}
                                 name="decimalPlaces"
                                 minValue={0}
                                 maxValue={9}/>
                    </div>
                    <div className="cf" />
                    <FormError form={this.form} name="decimalPlaces" />
                </div>

                <div className="row cf preview-row">
                    <div className="label">Preview</div>
                    <div className="element">

                        <div className="gd-field-number preview">
                            {gd.utils.Format.number(1234.56,this.form.getValue('decimalPlaces'),false)}
                        </div>

                    </div>
                    <div className="cf" />
                </div>

            </Form>
        );
    }
}



export default function renderStringFormFieldFormElement(field, props) {
    return <StringSettingsForm field={field} {...props} />;
}
